import {
  MRMS_MUTATIONS_ENUM,
} from './mrms.enum';

export const mrmsMutations = {
  [MRMS_MUTATIONS_ENUM.SET_MRMS_METADATA](state, payload) {
    state.rasterMetaData = payload;
  },
};
